import { defineComponent as m, h as s, mergeProps as o, ref as f } from "vue";
import { useMergedClsPrefix as a } from "./highrise1053.mjs";
import d, { ellipsisProps as u, createLineClampClass as c, createCursorClass as g } from "./highrise1172.mjs";
import C from "./highrise1173.mjs";
import h from "./highrise1101.mjs";
const y = m({
  name: "PerformantEllipsis",
  props: u,
  inheritAttrs: !1,
  setup(i, {
    attrs: p,
    slots: t
  }) {
    const n = f(!1), l = a();
    return h("-ellipsis", C, l), {
      mouseEntered: n,
      renderTrigger: () => {
        const {
          lineClamp: e
        } = i, r = l.value;
        return s("span", Object.assign({}, o(p, {
          class: [`${r}-ellipsis`, e !== void 0 ? c(r) : void 0, i.expandTrigger === "click" ? g(r, "pointer") : void 0],
          style: e === void 0 ? {
            textOverflow: "ellipsis"
          } : {
            "-webkit-line-clamp": e
          }
        }), {
          onMouseenter: () => {
            n.value = !0;
          }
        }), e ? t : s("span", null, t));
      }
    };
  },
  render() {
    return this.mouseEntered ? s(d, o({}, this.$attrs, this.$props), this.$slots) : this.renderTrigger();
  }
});
export {
  y as NPerformantEllipsis
};
